import { render, staticRenderFns } from "./RosterPatient.vue?vue&type=template&id=0fe3b706&scoped=true"
import script from "./RosterPatient.vue?vue&type=script&lang=js"
export * from "./RosterPatient.vue?vue&type=script&lang=js"
import style0 from "./RosterPatient.vue?vue&type=style&index=0&id=0fe3b706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3b706",
  null
  
)

export default component.exports